// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Container Query Breakpoints */
.vnsc-root {
  --vnsc-breakpoint-compact: 480px;
  --vnsc-breakpoint-medium: 768px;
  --vnsc-breakpoint-wide: 1200px;
  --vnsc-breakpoint-ultra: 1920px;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/breakpoints.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;AACjC","sourcesContent":["/* Design Tokens - Container Query Breakpoints */\r\n.vnsc-root {\r\n  --vnsc-breakpoint-compact: 480px;\r\n  --vnsc-breakpoint-medium: 768px;\r\n  --vnsc-breakpoint-wide: 1200px;\r\n  --vnsc-breakpoint-ultra: 1920px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
